import { useState } from "react"

export const useDrawer = <T = any,>() => {
    // Drawer visibility states
    const [isDrawerOpen, setIsDrawerOpen] = useState(false)

    // Generic open drawer function
    const openDrawer = () => {
        setIsDrawerOpen(true)
    }

    // Generic close drawer function
    const closeDrawer = () => {
        setIsDrawerOpen(false)
    }

    return {
        isDrawerOpen,
        openDrawer,
        closeDrawer,
    }
}
